export const MIN_OPTIONS_NUMBER = 2;

export const MAX_OPTIONS_NUMBER = 20;
